class ScrollButton extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  handleClick(event) {
    const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!anchor) return;

    const href = anchor.getAttribute('href') || '';
    if (!href.startsWith('#') || href === '#') return;

    const targetId = decodeURIComponent(href.slice(1));
    const target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();

    const header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;

    const isDesktop = typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 900px)').matches;
    const offsetAttr = isDesktop ? 'data-offset-desktop' : 'data-offset-mobile';
    const offsetFallback = this.getAttribute('data-offset');
    const offsetValue = this.getAttribute(offsetAttr) ?? offsetFallback ?? '0';
    const gap = Number.parseFloat(offsetValue) || 0;
    const targetTop = target.getBoundingClientRect().top + window.scrollY;
    const y = Math.max(0, targetTop - headerHeight - gap);

    const prefersReducedMotion =
      typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({ top: y, behavior: prefersReducedMotion ? 'auto' : 'smooth' });

    if (history && typeof history.pushState === 'function') {
      history.pushState(null, '', `#${encodeURIComponent(targetId)}`);
    } else {
      window.location.hash = targetId;
    }

    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }
}

if (!customElements.get('scroll-button')) {
  customElements.define('scroll-button', ScrollButton);
}

